import { render, staticRenderFns } from "./BrandProductList.vue?vue&type=template&id=2e708a58"
import script from "./BrandProductList.vue?vue&type=script&lang=js"
export * from "./BrandProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports